export default __webpack_public_path__ + "static/media/regreenbus_info_con_01.05f3fb57.png";